/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, EventEmitter, Output, Input} from '@angular/core';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-sites-location-changes-dialog',
  templateUrl: './location-changes-dialog.component.html'
})
export class LocationChangesDialogComponent {

  mId = 'locationChangesDialog';
  
  private mListeners = new Subject<LocationChangeUserResponse>();
  
  
  private show(): void {
    console.log("show()");
    $(`#${this.mId}`).modal("show");
  }
  
  private hide(): void {
    console.log("hide()");
    $(`#${this.mId}`).modal("hide");
  }
  
  
  saveClicked(): void {
    this.hide();
    this.mListeners.next(LocationChangeUserResponse.SAVE);
  }
  
  discardClicked(): void {
    this.hide();
    this.mListeners.next(LocationChangeUserResponse.DISCARD);
  }
  
  cancelClicked(): void {
    this.hide();
    this.mListeners.next(LocationChangeUserResponse.CANCEL);
  }
  
  async showAndWait(): Promise<LocationChangeUserResponse> {
    this.show();
    return await new Promise<LocationChangeUserResponse>((resolve, reject) => {
      const subscription = this.mListeners.subscribe(
        result => {
          resolve(result);
          subscription.unsubscribe();
        },
        error => {
          reject(error);
          subscription.unsubscribe();
        }
      );
    });
  }
  
}

export enum LocationChangeUserResponse {
  CANCEL = 'CANCEL',
  DISCARD = 'DISCARD',
  SAVE = 'SAVE'
}
